// store/index.js - обновим actions
import axios from 'axios';

const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

const state = {
  user: null,
};

const getters = {
  isAuthenticated: state => !!state.user,
  stateUser: state => state.user,
  // В local-сборке store.user пустой (аутентификации нет), но бэкенд там
  // отвечает как admin — поэтому по умолчанию считаем админом.
  isAdmin: state => process.env.VUE_APP_MODE === 'local' || state.user?.role === 'admin',
  currentUserUid: state => state.user?.uid || null,
};

const actions = {
  async register({dispatch}, form) {
    const response = await api.post('register', form);
    let UserForm = new FormData();
    UserForm.append('username', form.username);
    UserForm.append('password', form.password);
    await dispatch('logIn', UserForm);
    return response.data;
  },
  
  async logIn({dispatch}, user) {
    const response = await api.post('login', user, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    await dispatch('viewMe');
    return response.data;
  },
  
  async viewMe({commit, dispatch}) {
    try {
      const {data} = await api.get('users/whoami');
      await commit('setUser', data);
      await dispatch('fetchLidars');
      return data;
    } catch (error) {
      console.error('Failed to fetch user:', error);
      commit('setUser', null);
      throw error;
    }
  },
  
  async changeUserPassword(passwordData) {
    try {
      console.log('Sending password change request with data:', passwordData);
      console.log('Data type:', typeof passwordData);
      console.log('Data keys:', Object.keys(passwordData));
      
      const response = await api.post('/user/change-password', passwordData);
      console.log('Password change successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('Change password error:', error);
      
      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response data:', error.response.data);
        console.error('Error response headers:', error.response.headers);
      }
      
      throw error;
    }
  },

  async deleteUser({ commit }, { userId, password }) {
    try {
      console.log(`Deleting user ${userId}`);
      const response = await api.delete(`/user/${userId}`, {
        data: { password }
      });
      console.log('Delete response:', response.data);
      
      // Просто очищаем состояние пользователя без вызова logout
      commit('setUser', null);
      
      return response.data;
    } catch (error) {
      console.error('Delete user error:', error);
      throw error;
    }
  },

  async logOut({commit}) {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Logout error:', error);
      // Даже если произошла ошибка, все равно очищаем состояние
    } finally {
      commit('setUser', null);
    }
  },
  
  async updateUser({ dispatch }, userData) {
    try {
      const response = await api.patch('/user/profile', userData);
      await dispatch('viewMe'); // Обновляем данные пользователя
      return response.data;
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  }
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  logout(state){
    state.user = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};